define('modules/navigation/navigation_view',[
  'backbone',
  'jquery',
  '_',

  './nav_item_collection',
  'text!./nav_item_template.html',

  'modules/icons/icon_view'
], function (Backbone, $, _,
             ItemCollection,
             ItemTemplate,
             IconView) {
  'use strict';
  var NavView = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);

      this.collection = new ItemCollection();
      this.collection.on('change:active reset', function () {
        this.render();
      }, this);

      this.icons = {};

    },

    template: _.template(ItemTemplate),

    render: function () {
      this.$el.html('');
      var items = [];
      if (this.collection.length) {
        this.collection.each(function (item) {
          if (item.get('icon')) {
            this.icons[item.get('icon')] = new IconView({name: item.get('icon'), show_badge: item.get('badge')});
          }
          items.push(this.template(item.toJSON()));

        }, this);
        this.$el.html(items);
      }
      // render icon views
      _.each(this.icons, function (icon) {
        this.$('.js-icon-' + icon.name).html(icon.$el);
      }, this);

      return this;
    },

    remove: function () {
      this.$el.empty();
      this.stopListening();
      this.$el.off();
      return this;
    }
  });
  return NavView;
});

